import React, { useEffect, useState } from "react";
import { classNames } from "../../../../general/functions/propsComponent";
import { LogoFullColor } from "../../../../general/assets/assets";
import { inputanStringCheck } from "../../../../general/functions/validationCheck";
import { useDispatch, useSelector } from "react-redux";
import { GetParamBase64 } from "../../function/base64Function";
import { useNavigate, useSearchParams } from "react-router-dom";
import useValidationDataKonselor from "../../costumeHooks/useValidationDataKonselor";
import CameraAndAudioCheckingView from "../../../SessionMethodVideoModul/views/parts/CameraAndAudioCheckingView";
import { PostValidationSessionKonseling } from "../../actions/ValidationSessionKonselingActions";
import LottieLoadingLine from "../../../../general/components/lottie/lineLoading/LottieLoadingLine";
import AlertLayout from "../../../../general/components/Alert/alertLayout";
import { ExclamationCircle } from "react-bootstrap-icons";
import NetworkStatus from "../../../../general/components/networkStatus/NetworkStatus";

export default function PartValidationCode() {
  const [kode, setKode] = useState(null);
  const [isHold, setIsHold] = useState(true);
  const [showMess, setShowMess] = useState(false);
  const [mess, setMess] = useState(null);
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const storeValid = useSelector(
    (state) => state.km_post_validation_sesssion_konseling
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const kodeVC = searchParams.get("kodeVC");

  useEffect(() => {
    if (kodeVC != null && kodeVC != undefined && !isHold) {
      setLoading(true);
      setKode(kodeVC);
      dispatch(PostValidationSessionKonseling(kodeVC));
    }
  }, [kodeVC, isHold]);
  useEffect(() => {
    if (storeValid.success) {
      setLoading(false);
      console.log("berhasil login", storeValid.data);
      navigate("/pduli-session?pdulisession=" + storeValid.data.url.base64, {
        replace: true,
      });
    }
    if (storeValid.error) {
      setLoading(false);
      setMess("Kode Video Call tidak terdaftar.");
      setShowMess(true);
    }
  }, [storeValid]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCheckValid(true);
    if (inputanStringCheck(kode)) {
      setLoading(true);
      setShowMess(false);
      dispatch(PostValidationSessionKonseling(kode));
    }
  };
  return (
    <>
      {isHold ? (
        <CameraAndAudioCheckingView setIsHold={() => setIsHold(false)} />
      ) : (
        <>
          <NetworkStatus />
          {loading && (
            <div className="absolute top-0 w-full left-0 h-2 overflow-hidden bg-gray-900">
              <LottieLoadingLine />
            </div>
          )}

          <div className="bg-black flex flex-col justify-center items-center h-screen">
            <LogoFullColor className="h-16 lg:h-16" />
            <form className=" w-full max-w-sm " onSubmit={handleSubmit}>
              <div className="pt-4">
                <label
                  htmlFor="kode_uniq"
                  className="block text-sm font-medium text-gray-200 text-center"
                ></label>
                <div className="flex pt-2">
                  <input
                    type="text"
                    name="kode_uniq"
                    id="kode_uniq"
                    autoComplete="kode-uniq"
                    value={kode}
                    className={classNames(
                      checkValid && !inputanStringCheck(kode)
                        ? "border-red-600 border-s-2 border-y-2 border-r-0"
                        : "border-gray-300 ",
                      " border focus:outline-none focus:ring-none block w-full shadow-sm text-base rounded-s-md p-2"
                    )}
                    disabled={loading}
                    onChange={(v) => {
                      if (showMess) {
                        setShowMess(false);
                      }
                      setKode(v.target.value);
                    }}
                    placeholder="Kode Video Call"
                  />
                  <button
                    className="btn-primary rounded rounded-s-none rounded-e-md focus:outline-none focus:ring-0   "
                    // onClick={handleSubmit}
                    type="submit"
                    disabled={loading}
                  >
                    Masuk
                  </button>
                </div>
                <label
                  className={classNames(
                    checkValid && !inputanStringCheck(kode)
                      ? "block"
                      : "hidden",
                    "text-red-400 text-sm ml-2"
                  )}
                >
                  * Mohon masukan kode
                </label>
              </div>
              <div className="flex  justify-between  ">
                <div className="px-4 py-3 text-left ">
                  {/* <Link
                      to="/assessor/login"
                      className="underline hover:underline text-secondary-500 font-bold text-lg"
                    >
                      Back To Login
                    </Link> */}
                </div>
                <div className="px-4 py-3 text-right "></div>
              </div>
            </form>
          </div>
          {/*  */}
          {showMess && (
            <div className="absolute bottom-4 right-4">
              <div className="w-full transition-all duration-75 ease-in-out shadow-lg ">
                <div
                  className={
                    "text-white px-6 py-2 border-0 rounded relative  transition-all duration-75   bg-yellow-500 animate-fadeI"
                  }
                >
                  <div className="flex items-center">
                    <span className="text-xl inline-block mr-3 align-middle">
                      <ExclamationCircle className="h-7 w-7 text-white" />
                    </span>

                    <span className="inline-block align-middle mr-8 ">
                      <b className="capitalize">Perhatian!</b> {mess}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*  */}
        </>
      )}
    </>
  );
}
